import { useMutation, UseMutationResult } from 'react-query';
import { api } from '../api';
import { AxiosError } from 'axios';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { CarryForwardResourcesPayload, CarryForwardResultDB } from '../types/carry-forward';
import queryClient from '../query-client';

export type CarryForwardRequest = CarryForwardResourcesPayload;
export type CarryForwardResponse = CarryForwardResultDB;

async function carryForward(workpaperId: string, req: CarryForwardRequest): Promise<CarryForwardResponse> {
    const { data } = await api.post(`/workpapers/${workpaperId}/carry-forward`, req);
    return data;
}
// Intercom events should be triggered from components that call this hook.
export function useCarryForward(): UseMutationResult<CarryForwardResponse, AxiosError, CarryForwardRequest, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useMutation((req) => carryForward(workpaperId, req), {
        onSettled: () => {
            queryClient.invalidateQueries(['entries']);
            queryClient.invalidateQueries(['worksheets']);
        },
    });
}
